<template>
	<fragment>
		<GeminiScrollbar class="rht-view customer-engagement-alloca my-scroll-bar alloc-my-scrollbar">
			<div
				class="table-container"
				:style="{width: `${masterTableWidth}px`, minWidth: `${masterTableWidth}px`}" 
				:class="(allocations.length == 0)? 'empty-view':'filled-view'" 
			>
				<scroll-sync class="customer-engagement-scroll-set" horizontal>
					<div class="master-head" ref="masterHeadScroll">
						<!--Loop through the allocation data to set the month-year header-->
						<template v-for="(allocation,index) in allocations">
							<div class="master-head-month" :key="index">
								<h3 class="month-name">{{allocation.monthNameAndYear}}</h3>
							</div>
						</template>
					</div>
					<div class="table-wrapper">
						<div class="master-table-head-box">
							<div
								class="each-month each-month-header"
								:key="index"
								v-for="(allocation,index) in allocations"
							>
								<div class="master-table-head mh-days">
									<div>
										<div class="master-table-text right-table-header">Days</div>
									</div>
								</div>
								<div class="master-table-head mh-vac">
									<div>
										<div class="master-table-text right-table-header vac">Vac.</div>
									</div>
								</div>
								<div class="master-table-head mh-sick">
									<div>
										<div class="master-table-text right-table-header sick">Sick</div>
									</div>
								</div>
								<div class="master-table-head mh-other">
									<div>
										<div class="master-table-text right-table-header other">Other</div>
									</div>
								</div>
								<div class="master-table-head mh-act">
									<div>
										<div class="master-table-text right-table-header act">Act.</div>
									</div>
								</div>
								<div class="master-table-head mh-tv">
									<div>
										<div class="master-table-text right-table-header tv">Turnover</div>
									</div>
								</div>
							</div>
						</div>
						<div
							class="master-table report-master-table-set inner-master-table"
							:style="{width: `${masterTableWidth}px`, minWidth: `${masterTableWidth }px`}"
							v-bar
						>
							<scroll-sync group="report" vertical>
								<div class="master-table" ref="masterTableRight" :class="loaderClass">
									<div
										class="each-month"
										v-for="(allocation,allocationIndex) in allocations"
										:key="allocationIndex"
										ref="allocationRow"
									>
										<div class="month-table">
											<template
												v-for="(monthlyAllocation,index) in allocation.customerEngagementMonthlyAllocations"
											>
												<customer-engagement-allocation-month
													:monthlyAllocation="monthlyAllocation"
													:key="allocationIndex+'_'+index"
												/>
											</template>
										</div>
									</div>
								</div>
							</scroll-sync>
						</div>
					</div>
				</scroll-sync>
				<!-- Report -->
				<div class="month-report-bottom">
					<div class="report-left-list">
						<div
							class="each-month"
							v-for="(result,resultIndex) in results"
							:key="resultIndex"
							ref="allocationRow"
						>
							<div class="month-table bottom-alloc-gutters">
								<div class="single-flex-row">
									<div class="mh-days">
										<p class="right-td td-element-center">{{result.total.totalWorkingDays}}</p>
									</div>
									<div class="mh-vac">
										<p class="right-td td-element-center">{{result.total.vacations}}</p>
									</div>
									<div class="mh-sick">
										<p class="right-td td-element-center">{{result.total.sick}}</p>
									</div>
									<div class="mh-other">
										<p class="right-td td-element-center">{{result.total.other}}</p>
									</div>
									<div class="mh-act">
										<p class="right-td td-element-center">{{result.total.actualWorkingDays}}</p>
									</div>
									<div class="tv">
										<p class="right-td td-element-center">
											<i
												v-tooltip.left="`${$options.filters.money(result.total.turnOver)} €`"
											>{{result.total.turnOver | money | truncate(9)}}€</i>
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</GeminiScrollbar>
	</fragment>
</template>

<script>
import filters from "../../../../mixins/filters";

const CustomerEngagementAllocationMonth = () =>
  import("./CustomerEngagementAllocationMonth");

const { observer } = require("vue-mutation-observer");

export default {
  name: "CustomerEngagementAllocation",
  mixins: [filters],
  components: { CustomerEngagementAllocationMonth },
  data() {
    return {
      masterTableWidth: 0,
      masterTableFinalWidth: 0,
      monthTableWidth: 0,
      isDomReady: false,
      allocationLength: 0,
      loaderClass: ""
    };
  },
  directives: { observer },
  computed: {
    /**
     * Allocation data from store
     */
    allocations: function() {
      return this.$store.state.reports.customerEngagementAllocations;
    },
    results: function() {
      return this.$store.state.reports.reportAggregate;
    }
  },
  updated() {
    this.setTableWidth();
    this.updateLoader();
  },
  created() {
    // Hiding the loader once the component is created
    this.isDomReady = true;
    this.updateLoader();
  },
  mounted() {
    this.setTablePadding();
    setTimeout(() => {
      this.HeadHorizontalScroll();
    }, 500);
  },
  methods: {
    /**
     * Set the width after the data load
     */
    setTableWidth: function() {
      //Adding actual width
      this.masterTableWidth = 333.66 * this.allocations.length + 10;
    },
    setTablePadding: function() {
      setTimeout(() => {
        this.masterTableWidth += 100;
      }, 800);
    },
    /**
     * Set the loader class on all component loaded
     */
    updateLoader: function() {
      setTimeout(() => {
        if (
          typeof this.$refs.allocationRow !== "undefined" &&
          this.$refs.allocationRow.length > 0
        ) {
          this.loaderClass = "master-table-loaded";
        }
      }, 200);
    },

    HeadHorizontalScroll: function() {
      let ScrollElement = this.$refs.masterHeadScroll,
        scrollableElement = document.querySelector(
          ".alloc-my-scrollbar .gm-scroll-view"
        ),
        i = 0;

      ScrollElement.addEventListener("wheel", function(e) {
        //When dragging to left side
        if (e.deltaY < 0 && !e.shiftKey) {
          if (i >= 0) {
            //if Scroll left == 0
            scrollableElement.scrollLeft = i;
            i = i - 50;
          } else {
            i = 0;
          }
        }

        //Mouse wheel and horizontal scroll for allocation's headers
        else if (e.deltaY > 0 && !e.shiftKey) {
          if (i <= scrollableElement.scrollWidth) {
            //if Scroll left !== end of the div
            scrollableElement.scrollLeft = i;
            i = i + 50;
          } else {
            i = scrollableElement.scrollWidth;
          }
        }
      });
    }
  },
  watch: {
    /**
     * Watch if the allocation data is fetch
     */
    allocations: function() {
      // call the function after the allocation data is loaded
      this.setTableWidth();
    }
  }
};
</script>

<style scoped>
	.my-scroll-bar {
		height: 100vh;
		overflow-y: hidden;
	}

	.my-scroll-bar.gm-scrollbar-container .gm-scroll-view {
		overflow-y: hidden !important;
	}
	
	.each-month-header{
		padding-left: 16px;	
	}
	
	.each-month-header .mh-days,
	.each-month-header .mh-vac,
	.each-month-header .mh-sick,
	.each-month-header .mh-other,
	.each-month-header .mh-act{
		min-width: 44px;
		max-width: 44px;
		width: 44px;
		padding:0;
	}
	
	
	.month-report-bottom  .mh-days,
	.month-report-bottom  .mh-vac,
	.month-report-bottom  .mh-sick,
	.month-report-bottom  .mh-other,
	.month-report-bottom  .mh-act{
		min-width: 44px;
		max-width: 44px;
		width: 44px;
		padding:0;
	}
	
	
	.month-report-bottom  .bottom-alloc-gutters{
		padding-left: 16px;
	}
	
	.month-report-bottom .td-element-center,
	.each-month-header .master-table-head .master-table-text{
		text-align: center;
	}
	
	.month-report-bottom .tv,
	.each-month-header .mh-tv{
		min-width: calc(100% - 236px);
		min-width: -webkit-calc(100% - 236px);
		width: calc(100% - 236px);
		width: -webkit-calc(100% - 236px);
		max-width: calc(100% - 236px);
		max-width: -webkit-calc(100% - 236px);
	}
	
	/* .each-month-header .mh-days {
		min-width: 62px;
		max-width: 62px;
		width: 62px;
		padding-left: 16px;
	}

	.month-report-bottom .mh-days {
		min-width: 56px;
		max-width: 56px;
		width: 56px;
		padding-left: 16px;
	}

	.each-month-header .mh-vac,
	.month-report-bottom .mh-vac {
		min-width: 44px;
		max-width: 44px;
		width: 44px;
	}

	.each-month-header .mh-sick,
	.month-report-bottom .mh-sick {
		min-width: 44px;
		max-width: 44px;
		width: 44px;
	}

	.each-month-header .mh-other,
	.month-report-bottom .mh-other {
		min-width: 50px;
		max-width: 50px;
		width: 50px;
	}

	.each-month-header .mh-act,
	.month-report-bottom .mh-act {
		min-width: 42px;
		max-width: 42px;
		width: 42px;
	}

	.each-month-header .mh-tv,
	.month-report-bottom .tv {
		min-width: 70px;
		max-width: 70px;
		width: 70px;
	} */

	.each-month,
	.master-head-month {
		border-right: 1px solid #eef0f1;
	}



	/* .month-report-bottom .mh-act .td-element-center {
		text-align: left;
	} */

	/* Master table on customer engagement */
	.master-table {
		height: calc(100vh - 248px);
		max-height: calc(100vh - 248px);
		min-height: calc(100vh - 248px);
		/* padding-bottom: 16px; */
	}
	
	@media screen and (max-width: 1440px){
		.master-table {
			height: calc(100vh - 269px);
			max-height: calc(100vh - 269px);
			min-height: calc(100vh - 269px);
		}	
	}
	
	/* Month report bottom - result  */
	.month-report-bottom {
		height: auto;
	}

	.left-days-cell-i {
		vertical-align: middle !important;
		text-align: center !important;
		line-height: 27px !important;
	}

	/* no border bottom for this row */
	.month-report-bottom .single-flex-row {
		border-bottom: 0 !important;
	}
</style>
